export const state = () => ({
  isNewsletterActive: true,
});

export const getters = {
  getCounter(state) {
    return state.isNewsletter;
  },
};

export const mutations = {
  toggle(state) {
    state.isNewsletterActive = false;
  },
};
